import React, { useContext, useState } from "react";
import Fade from "react-reveal/Fade";
import { useRecoilState } from "recoil";
import { collapsedState } from "../../utils/recoil-atoms";
import { Link } from "gatsby";
import logo from "../../assets/images/tell-logo-white.png";
import logodark from "../../assets/images/tell-logo-black.png";
import { isAuthorised, getUserData, isLoggedIn } from "../../services/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon, faCogs, faLaptopCode, faAddressCard, faLink, faEye, faScrewdriver, faThLarge, faSitemap, faQrcode, faUserLock, faUserEdit, faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { admin_nav } from "../../state/admin_nav";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../../state/GlobalContextProvider";

const Navbar = () => {
  const [collapsed, setCollapsed] = useRecoilState(collapsedState);
  const [showAvatar, setShowAvatar] = useState(false);
  const dispatch = useContext(GlobalDispatchContext);
  const themeState = useContext(GlobalStateContext);

  const [selectedKey, setSelectedKey] = useState(false);
  const [isChildMenu, setIsChildMenu] = useState(false);
  const [childMenu, setChildMenu] = useState([]);
  const [pathParamArray, setPathParamArray] = useState({});
  const path = typeof window !== "undefined" ? window.location.pathname : "";

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  const userData = getUserData();

  React.useEffect(() => {
    let elementId = document.getElementById("navbar");
    document.addEventListener("scroll", () => {
      if (window.scrollY > 170) {
        elementId.classList.add("is-sticky");
      } else {
        elementId.classList.remove("is-sticky");
      }
    });

    setTimeout(function () {
      setShowAvatar(true)
    }, 200);
    window.scrollTo(0, 0);
  });

  const classOne = collapsed
    ? "collapse navbar-collapse"
    : "collapse navbar-collapse show";
  const classTwo = collapsed
    ? "navbar-toggler navbar-toggler-right collapsed"
    : "navbar-toggler navbar-toggler-right";

    const filterMainNavigation = (arr) => {
      return arr.filter((item) => {
        if(item.scope){
          if(isAuthorised(item.scope)){ return true; } else { return false; }
        }
        return true;
      });
    };

    const activate_menu = (key) => {
      setSelectedKey(key);
      var newActiveItem = admin_nav.filter(function (item) {
        return item.key == key;
      });
  
      if (newActiveItem[0].children !== undefined) {
       // handleChildMenu(newActiveItem[0].children);
      } else {
      //  setIsChildMenu(false);
      }
    };

    const filterNavigation = (arr) => {
      return arr.filter((item) => {

        if(item.type==="section_header"){ return false;}
        const location_keys = getPathParamsNameArray(item.location);
        const pparams_keys = getPathParamsNameArray(path);
  
        if(item.scope){
          if(!isAuthorised(item.scope)){ return false; }
        }
  
        if (item.dependant_regex) {
          var newRegex = new RegExp(item.dependant_regex);
          if (!newRegex.test(path)) {
            return false;
          }
  
          var i;
          var rpl_obj = {};
          if (location_keys) {
            for (i = 0; i < location_keys.length; i++) {
              if (location_keys[i].substr(0, 1) === ":") {
                rpl_obj[location_keys[i]] = pparams_keys[i];
              }
            }
          }
  
          var new_location = item.location;
          Object.keys(rpl_obj).map(function (keyName, keyIndex) {
            new_location = new_location.replace(keyName, rpl_obj[keyName]);
          });
  
          item.location = new_location;
          return item;
        }
  
        return true;
      });
    };

    const getPathParamsNameArray = (loc) => {
      const regex = /\(?([^/]+)\)?/g;
  
      const str = loc;
      let pathParamObj = [];
      let m;
      if (str !== undefined) {
        m = str.match(regex);
      }
  
      return m;
    };

  return (

<React.Fragment>
      <div id="navbar" className="navbar-area">
        <div className={"tarn-nav " + themeState.theme}>
          <div className="container-fluid">
            <nav className="navbar navbar-expand-lg navbar-light">
              <Link
                to="/"
                onClick={() => setCollapsed(true)}
                className="navbar-brand"
              >
                <img
                  src={themeState.theme === "light" ? logodark : logo}
                  alt="logo"
                />
                <img className="responsive-brand" src={logo} alt="logo" />
              </Link>

              <button
                onClick={toggleNavbar}
                className={classTwo}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-bar top-bar"></span>
                <span className="icon-bar middle-bar"></span>
                <span className="icon-bar bottom-bar"></span>
              </button>

              <div className={classOne} id="navbarSupportedContent">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link
                      to={isLoggedIn()?"/welcome/":"/"}
                      activeClassName="active"
                      onClick={() => setCollapsed(true)}
                      className="nav-link"
                    >
                      Home
                    </Link>
                  </li>
                 
                  {isAuthorised("help:getting-started") || isLoggedIn() === false ? (
                  <li className="nav-item">
                    <Link
                      to="#"
                      activeClassName="active"
                      onClick={(e) => e.preventDefault()}
                      className="nav-link"
                    >
                      GET STARTED <i className="bx bx-chevron-down"></i>
                    </Link>

                    <ul className="dropdown-menu">
                      <li className="nav-item">
                        <Link
                          to="/get-started/"
                          activeClassName="active"
                          onClick={() => setCollapsed(true)}
                          className="nav-link"
                        ><i>
                            <FontAwesomeIcon icon={faEye} />
                          </i>
                          Overview
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          to="/integration/"
                          activeClassName="active"
                          onClick={() => setCollapsed(true)}
                          className="nav-link"
                        ><i>
                            <FontAwesomeIcon icon={faLink} />
                          </i>
                          Integration Guide
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/configuration/"
                          activeClassName="active"
                          onClick={() => setCollapsed(true)}
                          className="nav-link"
                        ><i>
                            <FontAwesomeIcon icon={faScrewdriver} />
                          </i>
                          Configuration Guide
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/specification"
                          activeClassName="active"
                          onClick={() => setCollapsed(true)}
                          className="nav-link"
                        ><i>
                            <FontAwesomeIcon icon={faCogs} />
                          </i>
                          The Specification
                        </Link>
                      </li>
                    </ul>
                  </li>
                  ) : null}
                
                  {isAuthorised("*") ? (

                    

                    <li className="nav-item">
                      <Link
                        to="#"
                        activeClassName="active"
                        onClick={(e) => e.preventDefault()}
                        className="nav-link"
                      >
                        ADMIN AREA <i className="bx bx-chevron-down"></i>
                      </Link>

                      <ul class="dropdown-menu dropdown-menu-right">
                      {filterMainNavigation(admin_nav).map((menuItem, index) => (

                        
                          <li className="nav-item">
                          <Link
                          to={menuItem.location}
                            activeClassName="active"
                            onClick={() => setCollapsed(true)}
                            className="nav-link"
                          ><i>
                              <FontAwesomeIcon icon={menuItem.icon} />
                            </i>
                          {menuItem.name}
                          </Link>
                          {menuItem.children?(
                          <ul class="dropdown-menu">
                            {filterNavigation(menuItem.children).map((childItem, index) => (
                              <li className="nav-item">
                              <Link
                              to={childItem.location}
                                activeClassName="active"
                                onClick={() => setCollapsed(true)}
                                className="nav-link"
                              ><i>
                                  <FontAwesomeIcon icon={childItem.icon} />
                                </i>
                              {childItem.name}
                              </Link>
                              </li>
                            
                              ))}
                            </ul>):null}
                          
                          </li>
                ))}
                  </ul>
                     
                      
                    </li>
                  ) : null}
                  {isAuthorised("*") ? (
                    <li className="nav-item">
                      <a
                        href="#account_menu"
                        className="nav-link profile-avatar-nav"
                        data-toggle="dropdown"
                        data-caret="false"
                      >
                        <div className="dropdown-toggle w-8 h-8 rounded-full mt--10 overflow-hidden shadow-lg image-fit zoom-in mr-4">
                          {showAvatar ? (
                            <Fade>
                              <img alt="ProfilePic" src={userData.icon} />
                            </Fade>) : null}
                        </div>
                        <span className="ml-1 d-flex-inline">
                          <span>
                            {userData.first_name +
                              " " +
                              userData.last_name.substring(0, 1) +
                              "."}{" "}
                            <i className="bx bx-chevron-down"></i>
                          </span>
                        </span>
                      </a>

                      <ul className="dropdown-menu dropdown-menu-right">
                        <li className="nav-item">
                          <Link
                            to="/profile/"
                            activeClassName="active"
                            onClick={() => setCollapsed(true)}
                            className="nav-link"
                          ><i>
                              <FontAwesomeIcon icon={faUserEdit} />
                            </i>
                            Profile
                          </Link>
                        </li>

                        <li className="nav-item">
                          <Link
                            to="/profile/credentials"
                            activeClassName="active"
                            onClick={() => setCollapsed(true)}
                            className="nav-link"
                          ><i>
                              <FontAwesomeIcon icon={faUserLock} />
                            </i>
                            Password Update
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/profile/mfa"
                            activeClassName="active"
                            onClick={() => setCollapsed(true)}
                            className="nav-link"
                          ><i>
                              <FontAwesomeIcon icon={faQrcode} />
                            </i>
                            MFA Settings
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/logout/"
                            activeClassName="active"
                            onClick={() => setCollapsed(true)}
                            className="nav-link"
                          ><i>
                              <FontAwesomeIcon icon={faPowerOff} />
                            </i>
                            Sign Out
                          </Link>
                        </li>
                      </ul>
                    </li>
                  ) : null}
                </ul>
                {isAuthorised() === false ? (
                  <div className="others-option d-flex align-items-center">
                    <div className="option-item">
                      <Link
                        to="/register"
                        activeClassName="active"
                        onClick={() => setCollapsed(true)}
                        className="default-btn default-btn-theme-1"
                      >
                        REGISTER <span></span>
                      </Link>
                    </div>
                    <div className="option-item">
                      <Link
                        to="/login"
                        activeClassName="active"
                        onClick={() => setCollapsed(true)}
                        className="default-btn default-btn-theme-2"
                      >
                        SIGN-IN <span></span>
                      </Link>
                    </div>
                  </div>
                ) : null}

                <i className={"dark-light-toggle " + themeState.theme}>
                  <FontAwesomeIcon
                    icon={themeState.theme === "light" ? faSun : faMoon}
                    onClick={() => {
                      dispatch({ type: "TOGGLE_THEME" });
                    }}
                  />
                </i>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </React.Fragment>
    
  )


  return (
    <React.Fragment>
      <div id="navbar" className="navbar-area">
        <div className={"tarn-nav " + themeState.theme}>
          <div className="container-fluid">
            <nav className="navbar navbar-expand-lg navbar-light">
              <Link
                to="/"
                onClick={() => setCollapsed(true)}
                className="navbar-brand"
              >
                <img
                  src={themeState.theme === "light" ? logodark : logo}
                  alt="logo"
                />
                <img className="responsive-brand" src={logo} alt="logo" />
              </Link>

              <button
                onClick={toggleNavbar}
                className={classTwo}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-bar top-bar"></span>
                <span className="icon-bar middle-bar"></span>
                <span className="icon-bar bottom-bar"></span>
              </button>

              <div className={classOne} id="navbarSupportedContent">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link
                      to={isLoggedIn()?"/welcome/":"/"}
                      activeClassName="active"
                      onClick={() => setCollapsed(true)}
                      className="nav-link"
                    >
                      Home
                    </Link>
                  </li>
                 
                  {isAuthorised("help:getting-started") || isLoggedIn() === false ? (
                  <li className="nav-item">
                    <Link
                      to="#"
                      activeClassName="active"
                      onClick={(e) => e.preventDefault()}
                      className="nav-link"
                    >
                      GET STARTED <i className="bx bx-chevron-down"></i>
                    </Link>

                    <ul className="dropdown-menu">
                      <li className="nav-item">
                        <Link
                          to="/get-started/"
                          activeClassName="active"
                          onClick={() => setCollapsed(true)}
                          className="nav-link"
                        ><i>
                            <FontAwesomeIcon icon={faEye} />
                          </i>
                          Overview
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          to="/integration/"
                          activeClassName="active"
                          onClick={() => setCollapsed(true)}
                          className="nav-link"
                        ><i>
                            <FontAwesomeIcon icon={faLink} />
                          </i>
                          Integration Guide
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/configuration/"
                          activeClassName="active"
                          onClick={() => setCollapsed(true)}
                          className="nav-link"
                        ><i>
                            <FontAwesomeIcon icon={faScrewdriver} />
                          </i>
                          Configuration Guide
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/specification"
                          activeClassName="active"
                          onClick={() => setCollapsed(true)}
                          className="nav-link"
                        ><i>
                            <FontAwesomeIcon icon={faCogs} />
                          </i>
                          The Specification
                        </Link>
                      </li>
                    </ul>
                  </li>
                  ) : null}
                
                  {isAuthorised("*") ? (
                    <li className="nav-item">
                      <Link
                        to="#"
                        activeClassName="active"
                        onClick={(e) => e.preventDefault()}
                        className="nav-link"
                      >
                        ADMIN AREA <i className="bx bx-chevron-down"></i>
                      </Link>

                      <ul className="dropdown-menu dropdown-menu-right">
                        {isAuthorised("int:mgt") ? (
                          <li className="nav-item">
                            <Link
                              to="/interfaces/"
                              activeClassName="active"
                              onClick={() => setCollapsed(true)}
                              className="nav-link"
                            ><i>
                                <FontAwesomeIcon icon={faThLarge} />
                              </i>
                            Interfaces
                          </Link>
                          </li>
                        ) : null}
                        {isAuthorised("org:mgt") ? (
                          <li className="nav-item">
                            <Link
                              to="/organisation/"
                              activeClassName="active"
                              onClick={() => setCollapsed(true)}
                              className="nav-link"
                            ><i>
                                <FontAwesomeIcon icon={faSitemap} />
                              </i>
                            Organisation
                          </Link>
                          </li>
                        ) : null}
                        {isAuthorised("tpp:mgt") ? (
                          <li className="nav-item">
                            <Link
                              to="/tpp"
                              activeClassName="active"
                              onClick={() => setCollapsed(true)}
                              className="nav-link"
                            >
                              <i>
                                <FontAwesomeIcon icon={faAddressCard} />
                              </i>TPP Management
                          </Link>
                          <ul className="dropdown-menu">
                                                    <li className="nav-item">
                                                        <Link 
                                                            to="/courses" 
                                                            activeClassName="active"
                                                            onClick={() => setCollapsed(true)}
                                                            className="nav-link"
                                                        >
                                                            Courses
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link 
                                                            to="/course-details" 
                                                            activeClassName="active"
                                                            onClick={() => setCollapsed(true)}
                                                            className="nav-link"
                                                        >
                                                            Course Details
                                                        </Link>
                                                    </li>
                                                </ul>
                          </li>
                        ) : null}
                        {isAuthorised("test:mgt") ? (
                          <li className="nav-item">
                            <Link
                              to="/test-centre"
                              activeClassName="active"
                              onClick={() => setCollapsed(true)}
                              className="nav-link"
                            >
                              <i>
                                <FontAwesomeIcon icon={faLaptopCode} />
                              </i>Test Centre
                          </Link>
                          </li>
                        ) : null}

                      </ul>
                    </li>
                  ) : null}
                  {isAuthorised("*") ? (
                    <li className="nav-item">
                      <a
                        href="#account_menu"
                        className="nav-link profile-avatar-nav"
                        data-toggle="dropdown"
                        data-caret="false"
                      >
                        <div className="dropdown-toggle w-8 h-8 rounded-full mt--10 overflow-hidden shadow-lg image-fit zoom-in mr-4">
                          {showAvatar ? (
                            <Fade>
                              <img alt="ProfilePic" src={userData.icon} />
                            </Fade>) : null}
                        </div>
                        <span className="ml-1 d-flex-inline">
                          <span>
                            {userData.first_name +
                              " " +
                              userData.last_name.substring(0, 1) +
                              "."}{" "}
                            <i className="bx bx-chevron-down"></i>
                          </span>
                        </span>
                      </a>

                      <ul className="dropdown-menu dropdown-menu-right">
                        <li className="nav-item">
                          <Link
                            to="/profile/"
                            activeClassName="active"
                            onClick={() => setCollapsed(true)}
                            className="nav-link"
                          ><i>
                              <FontAwesomeIcon icon={faUserEdit} />
                            </i>
                            Profile
                          </Link>
                        </li>

                        <li className="nav-item">
                          <Link
                            to="/profile/credentials"
                            activeClassName="active"
                            onClick={() => setCollapsed(true)}
                            className="nav-link"
                          ><i>
                              <FontAwesomeIcon icon={faUserLock} />
                            </i>
                            Password Update
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/profile/mfa"
                            activeClassName="active"
                            onClick={() => setCollapsed(true)}
                            className="nav-link"
                          ><i>
                              <FontAwesomeIcon icon={faQrcode} />
                            </i>
                            MFA Settings
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/logout/"
                            activeClassName="active"
                            onClick={() => setCollapsed(true)}
                            className="nav-link"
                          ><i>
                              <FontAwesomeIcon icon={faPowerOff} />
                            </i>
                            Sign Out
                          </Link>
                        </li>
                      </ul>
                    </li>
                  ) : null}
                </ul>
                {isAuthorised() === false ? (
                  <div className="others-option d-flex align-items-center">
                    <div className="option-item">
                      <Link
                        to="/register"
                        activeClassName="active"
                        onClick={() => setCollapsed(true)}
                        className="default-btn default-btn-theme-1"
                      >
                        REGISTER <span></span>
                      </Link>
                    </div>
                    <div className="option-item">
                      <Link
                        to="/login"
                        activeClassName="active"
                        onClick={() => setCollapsed(true)}
                        className="default-btn default-btn-theme-2"
                      >
                        SIGN-IN <span></span>
                      </Link>
                    </div>
                  </div>
                ) : null}

                <i className={"dark-light-toggle " + themeState.theme}>
                  <FontAwesomeIcon
                    icon={themeState.theme === "light" ? faSun : faMoon}
                    onClick={() => {
                      dispatch({ type: "TOGGLE_THEME" });
                    }}
                  />
                </i>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Navbar;
